
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"138","height":"70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 61.892C5.749 57.6 14.778 48.252 36.908 45.2c29.092-1.908 67.246.954 77.738-10.97 5.246-4.292 12.877-13.353 13.354-25.276","stroke":"#747176","stroke-width":"1.908"}}),_c('path',{attrs:{"d":"M128.674 7.325a.953.953 0 00-1.348 0l-6.071 6.07a.955.955 0 001.349 1.35L128 9.349l5.396 5.396a.954.954 0 001.349-1.35l-6.071-6.07zm.28 1.629V8h-1.908v.954h1.908z","fill":"#6D6A6F"}})])
          )
        }
      }
    